const getCardNumberFormatted = (card) => card?.last4 ? card.last4.padStart(16, '\u2022') : '-';
export default getCardNumberFormatted;
